/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable sonarjs/no-duplicate-string */
import React from 'react';
import CornerComp from './CornerComp';
import EarlyPayoutComp from './EarlyPayoutComp';
import GoalComp from './GoalComp';

const EventDetailsTable = ({ goal, eventType, markets }) => {
  if ((goal.eventType === eventType.GOLDEN_GOAL && goal?.homeGoldenGoal)
    || (goal.eventType === eventType.GOAL_HOME)) {
    const isGoldenGoal = goal.eventType === eventType.GOLDEN_GOAL && goal?.homeGoldenGoal;
    return (
      <GoalComp
        homeGoal
        goal={goal}
        isGoldenGoal={isGoldenGoal}
      />
    );
  }

  if ((goal.eventType === eventType.GOLDEN_GOAL && goal?.awayGoldenGoal)
    || (goal.eventType === eventType.GOAL_AWAY)) {
    const isGoldenGoal = goal.eventType === eventType.GOLDEN_GOAL && goal?.awayGoldenGoal;
    return (
      <GoalComp
        goal={goal}
        isGoldenGoal={isGoldenGoal}
      />
    );
  }

  if (goal.eventType === eventType.EARLY_PAYOUT) {
    const { earlyPayoutSelections } = goal;
    return (
      <EarlyPayoutComp
        goal={goal}
        markets={markets}
        earlyPayoutSelections={earlyPayoutSelections}
      />
    );
  }

  if (goal.eventType === eventType.CORNER_HOME) {
    return (
      <CornerComp
        cornerHome
        event={goal}
      />
    );
  }
  if (goal.eventType === eventType.CORNER_AWAY) {
    return (
      <CornerComp
        event={goal}
      />
    );
  }
  return null;
};

export default EventDetailsTable;
